export enum DocumentStep {
    All = 0,
    Critical,
    Additional
}
